export default __webpack_public_path__ + "static/media/22--conversation-chat--communication-dialogue-discussion.16946e04.svg";